import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Admin} from './admin';
import {Login} from './login';
import { throwError, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from "@angular/router";
import {JwtHelperService} from '@auth0/angular-jwt';
import decode from 'jwt-decode';




@Injectable({
  providedIn: 'root'
})

export class AuthService {





  private loginUrl = '';    //login 
  private loginUp = '';  //registro administrador
  private loginRemenber= '';  // modificar contraseña
  private tokenVerify= '';  // modificar contraseña
  private loginUpUser= '';  // modificar contraseña
  private idAdmin = ''; // Admin?
  private addUser=''; //Añadir usuario



  dataAdmin!: Admin[];
  dataLogin!: Login[];
  estadoToken: boolean = false;

  userData:any ;
  respuesta:any;
  resToken: boolean = false;
  apiKey:any;
  user:any;
  usuario:any;
  token:string | null=null;
  isLogin = false;
  roleAs: string | null = null;
  redirectUrl: string = '/';
  logUrl: string = 'sign-in';
  prod = true;
 
 
	

  constructor(
    private _http: HttpClient,
    public router: Router,
    public jwtHelper: JwtHelperService
    
    ) {
		if (this.prod){

			 this.loginUrl = 'https://flux-data.net/login';    //login 
			 this.loginUp = 'https://flux-data.net/admin';  //registro administrador
			 this.loginRemenber= 'https://flux-data.net/loginRemenber';  // modificar contraseña
			 this.tokenVerify= 'https://flux-data.net/token';  // modificar contraseña
			 this.loginUpUser= 'https://flux-data.net/prof';  // modificar contraseña
			 this.idAdmin= 'https://flux-data.net/idAdmin';  // modificar contraseña
			 this.addUser= 'https://flux-data.net/addUser';  // modificar contraseña
		}else{

			 this.loginUrl = ' http://localhost:8080/login';    //login 
			 this.loginUp = ' http://localhost:8080/admin';  //registro administrador
			 this.loginRemenber= ' http://localhost:8080/loginRemenber';  // modificar contraseña
			 this.tokenVerify= ' http://localhost:8080/token';  // modificar contraseña
			 this.loginUpUser= ' http://localhost:8080/prof';  // modificar contraseña
			 this.idAdmin= ' http://localhost:8080/idAdmin';  // consular si es admin
			 this.addUser= ' http://localhost:8080/addUser';  // consular si es admin

		}



	}

  
    
       
  public isAuthenticated(): boolean {

          this.token  = localStorage.getItem('sfeJfsld8dsKld5lRld');
          // Check whether the token is expired and return
          // true or false
          //console.log("AQUI EN PUERTAS DE ISAUTH");
          
          if (this.token == null){
            return false;
          }else {
            return !this.jwtHelper.isTokenExpired(this.token);
          }
       
        }
        
                    

  postRegistro(dataAdmin: Admin) {
    return this._http
                  .post(this.loginUp,dataAdmin)
                  .pipe(
                          catchError(this.handleError)
                      );
   
  } 

  postRegistroUser(dataAdmin: Admin) {
    return this._http
                  .post(this.loginUpUser,dataAdmin)
                  .pipe(
                          catchError(this.handleError)
                      );
   
  }


  postLogin(dataLogin: Login) {
    return this._http
                  .post(this.loginUrl,dataLogin)
                  .pipe(
                          catchError(this.handleError)
                      );
   
  }
  postloginRemenber(dataLogin: Login) {
    return this._http
                  .post(this.loginRemenber, dataLogin)
                  .pipe(
                          catchError(this.handleError)
                      );
   
  }

  SignOut(){
    localStorage.removeItem('sfeJfsld8dsKld5lRld');
  }

  getAdmin(id:string){
	return this._http
	.post(this.loginRemenber, id)
	.pipe(
			catchError(this.handleError)
		);

  }

  postaddUser(email: any){
	return this._http
	.post(this.addUser, email)
	.pipe(
			catchError(this.handleError)
		);

  }


  getUser(){
    let token2 = localStorage.getItem('sfeJfsld8dsKld5lRld');
    if (token2){
      const tokenPayload:any= decode(token2);
      
      return tokenPayload.usuario;
    }else {
      //console.log("SIN TOKEN");
      return false;
      
    }
    
    
  }

  getEmail(){
    let token2 = localStorage.getItem('sfeJfsld8dsKld5lRld');
    if (token2){
      const tokenPayload:any= decode(token2);
      
      return tokenPayload.usuario.email;
    }else {
      //console.log("SIN TOKEN");
      return false;
      
    }
    
    
  }

  getId(){
    let token2 = localStorage.getItem('sfeJfsld8dsKld5lRld');
    if (token2){
      const tokenPayload:any= decode(token2);
      
      return tokenPayload.usuario._id;
    }else {
      //console.log("SIN TOKEN");
      return false;
      
    }
    
    
  }

  getRol(){
    let token2 = localStorage.getItem('sfeJfsld8dsKld5lRld');
    if (token2){
      const tokenPayload:any= decode(token2);
      
      return tokenPayload.usuario.rol;
    }else {
      console.log("SIN TOKEN");
      return false;
      
    }
    
    
  }



  getRedirectUrl(): string {
    return this.redirectUrl;
  }
  setRedirectUrl(url: string): void {
    this.redirectUrl = url;
  }

  getLoginUrl(): string {
    return this.logUrl;
  }



  // Implement a method to handle errors if any
  private handleError(err: HttpErrorResponse | any) {
 
	let errorHtml = err.error.err.message
    //console.error('Ha ocurrido un error:', err);
    alert (errorHtml);
    
    return throwError(err.message || err);
  }





}
